<!-- Modals -->
<app-deprecated-modal-form
    #createModal
    headerText="performance.feedback-index.createFeedback"
    [form]="feedbackForm"
    (save)="onCreate(feedbackForm.feedback, feedbackForm)"
>
    <app-form-feedback #feedbackForm></app-form-feedback>
</app-deprecated-modal-form>

<!-- Body -->
<div class="ui basic segment">
    <app-header title="performance.feedback-index.mainTitle" [menuService]="tabMenuService">
        <div class="buttons">
            <ui-button *permission="createPermission" (click)="createModal.show()" type="primary">
                <mat-icon svgIcon="plus" aria-hidden="true"></mat-icon>
                <span>{{ 'performance.feedback-index.addFeedback' | translate }}</span>
            </ui-button>
        </div>
    </app-header>

    <app-table [table]="table">
        <app-empty-state
            label="performance.feedback-index.noFeedback"
            src="/assets/illustrations/clipboard-speech-bubble.png"
        >
        </app-empty-state>
    </app-table>
</div>
